import { useTemplatesContext } from "@/pages/templates/context/templatesContext";
import {
	Dialog,
	DialogActions,
	DialogContent,
	DialogTitle,
} from "@mui/material";
import Button from "@mui/material/Button";
import Grid2 from "@mui/material/Grid2";
import { useState } from "react";

const VITE_DOCUMENT_PATH =
	import.meta.env.VITE_DOCUMENT_PATH ||
	"https://mill-cmms.roanokesteel.com/vaultix/";

export const PreviewerAttachment = () => {
	const [fullWidth, setFullWidth] = useState(true);

	const {
		state: { rowSelectedInAttachment, displayViewerAttachment },
		actions: { setDisplayViewerAttachment },
	} = useTemplatesContext();

	const handleCancel = () => {
		setDisplayViewerAttachment(false);
	};

	return (
		<>
			<Dialog
				fullWidth={fullWidth}
				open={displayViewerAttachment}
				onClose={() => handleCancel()}
			>
				<Grid2 container style={{ padding: "15px 0 0" }}>
					<Grid2 size={{ md: 12, xs: 12 }}>
						<DialogTitle
							id="max-width-dialog-title"
							style={{ padding: "5px 24px 10px" }}
						>
							{rowSelectedInAttachment?.FileName}
						</DialogTitle>
					</Grid2>
					<Grid2 container>
						<DialogContent
							dividers
							style={{ height: "50vh", paddingTop: "20px" }}
						>
							<Grid2
								container
								style={{
									justifyContent: "center",
									alignItems: "center",
									height: "100%",
									maxHeight: "100%",
									minHeight: "100%",
									paddingBottom: "5px",
								}}
								size={{ md: 12, xs: 12 }}
							>
								<object
									data={`${VITE_DOCUMENT_PATH}${rowSelectedInAttachment?.Path}`}
									type="image/PNG"
									style={{
										objectFit: "contain",
										height: "100%",
										width: "100%",
										display: "flex",
										alignItems: "center",
									}}
								>
									<img
										style={{
											objectPosition: "center",
											verticalAlign: "middle",
											objectFit: "contain",
											height: "50%",
											width: "100%",
										}}
										src="img/notFound.jpg"
										alt={`Drawing: ${rowSelectedInAttachment?.FileName}`}
										loading="lazy"
									/>
								</object>
							</Grid2>
						</DialogContent>
					</Grid2>

					<Grid2 style={{ padding: "20px 0" }} size={{ md: 12, xs: 12 }}>
						<DialogActions style={{ padding: "0px 24px" }}>
							<Grid2 size={{ md: 3, xs: 6 }}>
								<Button
									fullWidth
									variant="contained"
									color="inherit"
									onClick={handleCancel}
								>
									CLOSE
								</Button>
							</Grid2>
						</DialogActions>
					</Grid2>
				</Grid2>
			</Dialog>
		</>
	);
};
